import { createSlice } from "@reduxjs/toolkit";
import { iProductDetails, iProductState, REDUCER_NAME } from "./Types";
import { getProductById, getProductList , getBestSellingProduct} from "./ThunkActions";

const initialState: iProductState = {
  isLoading: false,
  products: [], // Always an array
  selectedProduct: undefined, // Optional single product
  errorMessage: null,
  bestSellingProducts:[],
   pagination: null, // ✅ initialize
  
};

export const productSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetProductState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductList.pending, (state) => {
        state.isLoading = true;
      })
     .addCase(getProductList.fulfilled, (state, action) => {
      // @ts-expect-error
  const payload = action.payload as {
    data: iProductDetails[];
    pagination?: {
      currentPage: number;
      totalPages: number;
      limit: number;
      totalCount: number;
    } | null;
  };

  state.products = payload?.data ?? [];
  state.pagination = payload?.pagination ?? null;
  state.isLoading = false;
  state.errorMessage = null;
})

      
      .addCase(getProductList.rejected, (state, action) => {
        state.errorMessage = (action.payload as { message?: string })?.message || "Failed to fetch products";
        state.isLoading = false;
      })
      .addCase(getProductById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProductById.fulfilled, (state, action) => {
        const payload = action.payload as { data: iProductDetails };
        if (payload && payload.data) {
          state.selectedProduct = payload.data;
        }
        state.isLoading = false;
      })
      .addCase(getProductById.rejected, (state, action) => {
        state.errorMessage = (action.payload as { message?: string })?.message || "Failed to fetch product details";
        state.isLoading = false;
      })
      .addCase(getBestSellingProduct.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getBestSellingProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        // Safely access the data property

        state.bestSellingProducts = action.payload?.data || null;
        state.errorMessage = null;
      })
      .addCase(getBestSellingProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.bestSellingProducts = [];
        state.errorMessage = typeof action.payload === 'object' && action.payload 
        // @ts-expect-error
            ? (action.payload as iStateMessage).message
            : "Failed to fetch products";
     })
  },
  
});

export const { resetProductState } = productSlice.actions;
export default productSlice.reducer;
